import {getClientId} from '../../auth/auth.service';
import {RoleTypeName, User} from '../../users/users.types';

export function doesUserHaveRole(user: User, role: RoleTypeName) {
  if (!user) return false;

  const clientId = getClientId();

  return (
    user.userRoles.includes(RoleTypeName.ClinchAdmin) ||
    (user.userClients[clientId] && user.userClients[clientId].userRoles.includes(role))
  );
}
